import React from "react";
import { useNavigate } from "react-router-dom";
import EligibilityDropzone from "components/admin/EligibilityDropzone";
import { uploadEligibilityFile } from "../../api/eligibilities";
import { toast } from "react-toastify";
import { useMutation } from "@tanstack/react-query";
import { useAuth0 } from "@auth0/auth0-react";

const UploadPage: React.FC = () => {
  const { getAccessTokenSilently } = useAuth0();
  const navigate = useNavigate();

  const mutation = useMutation({
    mutationFn: async (file: File) => {
      const token = await getAccessTokenSilently();
      return uploadEligibilityFile(file, token);
    },
    onSuccess: () => {
      toast.success("File uploaded successfully!");
      navigate("/admin/eligibilities");
    },
    onError: (err: any) => {
      toast.error("Upload failed: " + (err?.toString() || "Unknown error"));
    },
  });

  return (
    <div className="max-w-xl mx-auto mt-12 p-8 bg-white rounded shadow">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-bold">Upload Eligibilities</h1>
        {mutation.isPending && (
          <div className="flex items-center">
            <svg className="animate-spin h-6 w-6 text-blue-500" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
            </svg>
            <span className="ml-2 text-blue-600 text-base">Uploading...</span>
          </div>
        )}
      </div>
      <EligibilityDropzone onFile={(file) => mutation.mutate(file)} />
    </div>
  );
};

export default UploadPage;
